export const routes = {
  authIms: 'ims',
  dashboard: 'dashboard',
  comingSoon: 'coming-soon',
  investments: 'investments',
  details: 'details',
  transact: 'transact',
  tracking: 'tracking',
  correspondence: 'correspondence',
  settings: 'settings',
  legal: 'legal'
} as const;
